import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import EaPaid from '@propertypal/shared/src/resources/icons/products/paid-social-media-icon.svg';
import Facebook from '@propertypal/shared/src/resources/icons/products/social-facebook.svg?url';
import Instagram from '@propertypal/shared/src/resources/icons/products/social-instagram.svg?url';
import PaidSocialMediaMockup from '@propertypal/shared/src/resources/images/paid-social-media/social-media-3.png';
import ProductsPageHeader, { ProcutsHeaderIcon } from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import { Box } from '@propertypal/web-ui/src/layout';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { FeaturesItem, FeaturesList } from '@propertypal/web-ui/src/products/ProductsFeatures.style';
import { Text, LinkText } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Paid Social Media Advertising - PropertyPal',
  description: 'Reach A Wider Audience And Not Just Those Who Follow The PropertyPal Social Media Channels.',
  url: `/products/developers/paid-social-media-advertising`,
};

const featureItems = [
  `Bespoke graphics with development and/or agent branding`,
  `Test copy and creative variations`,
  `Reach a broader and more varied audience`,
  `Relevant for current advertising and future phases`,
  `Data to calculate Return On Ad Spend (ROAS)`,
];

const icons: ProcutsHeaderIcon[] = [
  {
    src: Facebook.src,
    heading: 'Facebook Stories',
    text: `260,000+ Facebook Followers`,
    link: (
      <LinkText
        href="https://www.facebook.com/propertypal"
        target="_blank"
        rel="noreferrer"
        display="flex"
        alignItems="center"
        gap={5}
        mt={10}
      >
        <span>Follow us on Facebook</span>
        <FontAwesomeIcon icon={faChevronRight} size={14} />
      </LinkText>
    ),
    headingSize: 20,
    headingMt: 20,
    textSize: 16,
    textMt: 10,
    maxW: 220,
  },
  {
    src: Instagram.src,
    heading: 'Instagram Stories',
    text: `43,900+ Instagram Followers`,
    link: (
      <LinkText
        href="https://www.instagram.com/propertypal/"
        target="_blank"
        rel="noreferrer"
        display="flex"
        alignItems="center"
        gap={5}
        mt={10}
      >
        <span>Follow us on Instagram</span>
        <FontAwesomeIcon icon={faChevronRight} size={14} />
      </LinkText>
    ),
    headingSize: 20,
    headingMt: 20,
    textSize: 16,
    textMt: 10,
    maxW: 220,
  },
];

const PaidSocialMediaAdvertising = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Paid Social Media Advertising"
        text="Reach a wider audience and not just those who follow the PropertyPal social media channels"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 950 }}
        icon={<EaPaid />}
        icons={icons}
        iconsJustifyCenter
      />
      <ProductScreenTabs
        aspectRatio="451 / 900"
        mockupWidth={230}
        maxW={940}
        tabsMt={0}
        tabPadding={210}
        breakpoint={950}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        mockup={{
          src: PaidSocialMediaMockup.src,
          alt: 'Paid Social Media Advertising',
        }}
        content={
          <Box maxWidth={500}>
            <Text mb={20} lineHeight={25} align="left">
              With a monthly reach of over 5 million people, PropertyPal&apos;s Social platforms offer a fantastic
              targeting option for potential new leads.
            </Text>
            <Text mb={20} lineHeight={25} align="left">
              A Paid promotion on PropertyPal&apos;s Social Media will link directly back to your listing on
              PropertyPal, supercharging the exposure your Development to new audiences and driving more enquiries than
              an organic social media post.
            </Text>
            <FeaturesList>
              {featureItems.map((f) => (
                <FeaturesItem key={f}>
                  <Text>{f}</Text>
                </FeaturesItem>
              ))}
            </FeaturesList>
            <Text mt={20} fontSize={14}>
              Cost includes setup, artwork, copywriting and optimisation.
            </Text>
          </Box>
        }
        staticTabs
        smallPrint="Statistics as of May 2024"
        smallPrintMt={65}
        pb={20}
      />
      <ProductsContact reason="Paid Social Media Advertising" />
    </>
  );
};

export default PaidSocialMediaAdvertising;
